export default __webpack_public_path__ + "static/media/WD-Logo.26d44690.svg";